import { render, staticRenderFns } from "./UsersPrivilegeServicesReservationTreatmentPlan.vue?vue&type=template&id=6e75e68e&scoped=true&"
import script from "./UsersPrivilegeServicesReservationTreatmentPlan.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeServicesReservationTreatmentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75e68e",
  null
  
)

export default component.exports